import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/calculator_d2c.png'
import _imports_1 from '@/assets/image/shopcart/calculator_b2b.png'
import _imports_2 from '@/assets/image/authGuide.png'
import _imports_3 from '@/assets/image/vipImg/vip_icon_remind.png'


const _withScopeId = n => (_pushScopeId("data-v-640405a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "name line--2 flex" }
const _hoisted_2 = {
  key: 0,
  class: "seasonTag"
}
const _hoisted_3 = {
  key: 0,
  style: {"display":"inline-block","padding":"5px 10px","border":"1px solid #ccc","border-radius":"4px","margin":"5px 0"}
}
const _hoisted_4 = { for: "" }
const _hoisted_5 = { style: {"padding":"0 4px"} }
const _hoisted_6 = {
  key: 1,
  class: "shop flex-ter"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  style: {"height":"10px"}
}
const _hoisted_9 = { style: {"line-height":"1.3"} }
const _hoisted_10 = { class: "detail flex-ter cursor-pt" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-bianzu71" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, "良品率が高い・価格競争力が高い・1688内の売れ筋商品あり", -1))
const _hoisted_13 = { class: "detail flex-ter cursor-pt" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-bianzu71" }, null, -1))
const _hoisted_15 = {
  key: 6,
  class: "fee-tab"
}
const _hoisted_16 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_question_active.png",
  alt: ""
}
const _hoisted_17 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_question.png",
  alt: ""
}
const _hoisted_18 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_question_active.png",
  alt: ""
}
const _hoisted_19 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_question.png",
  alt: ""
}
const _hoisted_20 = { class: "fee" }
const _hoisted_21 = {
  key: 0,
  class: "fee-price"
}
const _hoisted_22 = { class: "flex-ter" }
const _hoisted_23 = {
  key: 0,
  class: "fee-label"
}
const _hoisted_24 = {
  key: 1,
  class: "fee-label"
}
const _hoisted_25 = { class: "fee-rmb" }
const _hoisted_26 = {
  class: "fee-yan",
  style: {"position":"relative","top":"4px"}
}
const _hoisted_27 = { class: "fee-rmb" }
const _hoisted_28 = {
  class: "fee-yan",
  style: {"position":"relative","top":"4px"}
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 5,
  class: "special-tag"
}
const _hoisted_31 = {
  key: 0,
  class: "flex-ter mt_15"
}
const _hoisted_32 = { class: "fee-label" }
const _hoisted_33 = { class: "buy-minnum delLine" }
const _hoisted_34 = { class: "flex-ter mt_15" }
const _hoisted_35 = { class: "fee-label" }
const _hoisted_36 = { class: "buy-minnum" }
const _hoisted_37 = {
  key: 1,
  class: "fee-price"
}
const _hoisted_38 = { class: "flex-ter" }
const _hoisted_39 = { class: "fee-label" }
const _hoisted_40 = { class: "fee-yan line-through" }
const _hoisted_41 = { class: "fee-yan line-through" }
const _hoisted_42 = {
  class: "flex-ter",
  style: {"margin":"15px 0","position":"relative"}
}
const _hoisted_43 = { class: "fee-label" }
const _hoisted_44 = { class: "fee-range" }
const _hoisted_45 = { class: "fee-rmb" }
const _hoisted_46 = { class: "fee-yan" }
const _hoisted_47 = { class: "pddTips" }
const _hoisted_48 = { class: "flex-ter mt_15" }
const _hoisted_49 = { class: "fee-label" }
const _hoisted_50 = { class: "buy-minnum" }
const _hoisted_51 = {
  key: 2,
  class: "fee-stair flex-ter"
}
const _hoisted_52 = { class: "fee-label flex-col-ard" }
const _hoisted_53 = { class: "fee-label-price" }
const _hoisted_54 = { class: "stair-amount" }
const _hoisted_55 = {
  key: 1,
  class: "fee-price"
}
const _hoisted_56 = { class: "flex-ter" }
const _hoisted_57 = { class: "fee-label" }
const _hoisted_58 = { class: "fee-rmb" }
const _hoisted_59 = {
  class: "fee-yan",
  style: {"position":"relative","top":"4px"}
}
const _hoisted_60 = {
  key: 7,
  class: "price-tip"
}
const _hoisted_61 = { class: "flex" }
const _hoisted_62 = { class: "all-estimate-price" }
const _hoisted_63 = {
  key: 0,
  alt: "",
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_0,
  class: "calculatorIcon"
}
const _hoisted_64 = {
  key: 1,
  alt: "",
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_1,
  class: "calculatorIcon"
}
const _hoisted_65 = {
  key: 0,
  class: "no-choose-sku"
}
const _hoisted_66 = { class: "left" }
const _hoisted_67 = {
  key: 0,
  class: "left"
}
const _hoisted_68 = { class: "top" }
const _hoisted_69 = { class: "label-text" }
const _hoisted_70 = {
  key: 0,
  class: "all-price"
}
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "y" }, null, -1))
const _hoisted_73 = { class: "amount" }
const _hoisted_74 = { class: "sing-estimate-price" }
const _hoisted_75 = {
  key: 1,
  class: "left"
}
const _hoisted_76 = { class: "top" }
const _hoisted_77 = { class: "label-text" }
const _hoisted_78 = { class: "all-price" }
const _hoisted_79 = { class: "singleAmt" }
const _hoisted_80 = {
  key: 0,
  class: "tips"
}
const _hoisted_81 = { class: "sku-aomunt" }
const _hoisted_82 = {
  key: 0,
  class: "hasWaterMark"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = ["href"]
const _hoisted_85 = {
  key: 10,
  class: "flex-end rel",
  style: {"margin-right":"40px"}
}
const _hoisted_86 = { class: "auth-tip abs flex-ter animated slow fadeIn" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "abs-wrap",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_88 = {
  class: "rel",
  style: {"width":"210px"}
}
const _hoisted_89 = {
  key: 1,
  class: "auth-btn flex-center"
}
const _hoisted_90 = {
  key: 2,
  class: "auth-btn flex-center"
}
const _hoisted_91 = { style: {"padding":"25px"} }
const _hoisted_92 = { class: "title" }
const _hoisted_93 = { style: {"padding":"10px 0"} }
const _hoisted_94 = { class: "waring_header" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_96 = { class: "waring_tips" }
const _hoisted_97 = { class: "footer" }

import { t } from '@/plugins/i18n'
import { useRouter, useRoute } from 'vue-router'
import { ref, computed, watch, Ref, onMounted, onUnmounted, nextTick, reactive } from 'vue'
import SkuMap from './SkuMap.vue'
import ColumnModal from './ColumnModal.vue'
// import { formatMoney } from '@/plugins/utils'
import { confirmLogin, confirmFinishAdd, confirmApiUnbind } from '@/util/useConfirm'
import { addCart as addCartApi, isFirstAdd } from '@/apis/shopcart'
import { getAvailableVipTemplate } from '@/apis/usercenter'
import { getListImageConfig, getUserUsageInfo, postAddNum } from '@/apis/search'
import { useRequest } from '@/util/useLoading'
import { saveImgs } from '@/util/useSave'
import { ElMessage, ElMessageBox } from 'element-plus'
import { isD2C, useRtfix, useSite2Station, isJA, useSite, isEN, isKO, getCustomerNationCode2, useSite2Code, isMultiStore, getWarehouseCode } from '@/store'
import { publishProduct, getShopInfo } from '@/apis/user'
import { setAdt } from '@/util/calcAdt'
import LogoIcon from '@/components/common/LogoIcon.vue'
import PreviewSku from './PreviewSku.vue'
import { useStore } from 'vuex'
import { calcCeil, formatMoneyDirection, showCurrentUnit, calcJpyToRmb, formatMoneyRange } from '@/util/useYan'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import AbnormalGoodsTip from '@/components/common/AbnormalGoodsTip.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import BlackWarningTip from '@/components/BlackGoods/BlackWarningTip.vue'
import TiktokUp from './TiktokUp.vue'
import bus from '@/util/useBus'
import { ShopType, Site } from '@/common/const'
import useBrandAuth from './brandAuth'
import CostCalc from '@/views/microapp/CostCalc.vue'
import microApp from '@micro-zoe/micro-app'
import { getShopLogistics } from '@/apis/setup'
import { debounce } from 'lodash'
import { getAdtList } from '@/apis/addition'
import { COUNTRY } from '@/global'
import { extCalcParamVO, extProductRespDTO } from '../data'
import { request } from '@/config/request/interceptors'
import { CalcParamVO, CalcResultVO, CustomerAdditionRespDTO, ShipParamVO } from '@/service/settlement'
import { CustomerShopShipRespDTO } from '@/service/customer'
import { useLocalStorage } from '@vueuse/core'
import { ttsCreatProductCheck } from '@/apis/api'
import FreeShipping from './FreeShipping.vue'
// 成本计算器

export default /*#__PURE__*/_defineComponent({
  props: {
    product: { type: null, required: true },
    skuLoading: { type: Boolean, required: true },
    isLive: { type: Boolean, required: true },
    isMultiGoods: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
  product: extProductRespDTO,
  skuLoading: boolean,
  isLive: boolean,
  isMultiGoods: boolean
}
const costVisible = ref(false)
// tictok 组件引用
const tiktokUpRef = ref()

const [needAuth, toAuth] = useBrandAuth()
// 水印相关
const isMark = computed(() => (props.product.productTag === 1 && !isJA()) || (isJA() && props.product.countryProductTag === 1))

const stationCode = useSite2Station()
const visible = ref(false)
const languageCode = ref(
  {
    [Site.JA]: 'ja',
    [Site.KO]: 'ko',
    [Site.EN]: 'en'
  }[stationCode]
)
const visibleOnce: Ref<boolean | null> = ref(false)

const store = useStore()
const router = useRouter()

const route = useRoute()
// 会员折扣率
const memberRate = computed(() => store.getters.memberRate)
const isLogin = computed(() => store.getters.isLogin)
// 升级会员弹窗
const openUpVipVisible = ref(false)
// 会员信息
const membership = store.getters.membership
// 店铺信息
const curshop = computed(() => store.getters?.shopInfo)
// 总的水印次数Y剩余次数
const vipNum = ref({ X: 0, Y: 0 } as any)
// 水印次数列表
const numListConfig = ref()
const vipLevelList = ref([])
const showMembershipTemplateId = ref()
const calculatorStorageParam = computed(() => `Calculator_${isD2C() ? 1 : 2}_goods`)
const tourOpen = ref(false)
const calcParmas = useLocalStorage<extCalcParamVO>(calculatorStorageParam.value, {})
// 跳转去升级会员
const upVipClick = () => {
  router.push(useRtfix('VipLevel'))
}

onMounted(() => {
  // 清空缓存数据
  calcParmas.value = {}
  if (!isLogin.value) {
    getAvailableVipTemplate({ stationCode }).then((res) => {
      vipLevelList.value = res.data?.filter((item: any) => (item.templateLevel ?? 0) <= 5)
      showMembershipTemplateId.value = getTopNotProMemberTemplateId(vipLevelList.value)
    })
    return
  } else {
    showMembershipTemplateId.value = store.getters.user?.membership?.membershipTemplateId
  }
  // 获取次数
  getListImageConfig({}).then(res => {
    if (res.success) {
      numListConfig.value = res.data
    }
  })
  // getLimitNum()
  getAvailableVipTemplate({ stationCode }).then((res) => {
    vipLevelList.value = res.data?.filter((item: any) => (item.templateLevel ?? 0) <= 5)
    const userMemberShipTemplateId = store.getters.user?.membership?.membershipTemplateId
    showMembershipTemplateId.value = userMemberShipTemplateId
  })
})

watch(() => props.product, async () => {
  // 未登录的韩国商品需要展示授权按钮
  if (!store.getters.isLogin && props.product.country === COUNTRY.KR) {
    needAuth.value = 1
  }
})
// 获取不是pro会员的最高会员
const getTopNotProMemberTemplateId = (vipList: any[]) => {
  if (vipList.length) {
    const notProList = vipList.filter(
      (item) => (item.templateLevel ?? 0) < 5
    )
    return notProList[notProList.length - 1]?.membershipTemplateId
  }
  return 0
}
/** 获取当前限制次数 */
const getLimitNum = async () => {
  vipNum.value = {
    X: 999,
    Y: 1
  }
  // const res = await getUserUsageInfo({})
  // if (res.success) {
  //   const restNum = Math.max(0, res.data.maxNum - res.data.num)
  // } else {
  //   return 999
  // }
}
// 售卖模式1批发2一件代发
// const saleType = ref(1)

const data = computed(() => props.product)
// 是否黑名单商品
const isBlackGood = computed(() => props?.product?.blackTag === 1)

const isAllCalUser = computed(() => store.state.route.isAllCalUser)
// 是否是线下商品
// 英韩除线下都需要下载
// 日本 一价全包不需要
const underlineGood = computed(() => {
  const product: any = props.product
  if (!product) return
  if (!isJA()) return false
  // 过滤一价全包
  if (product.isAllCal) return true
  // 过滤非线下商品
  if (product.channel !== 5) return false
  // 过滤非choice
  const isNotChoice = !product.choiceFlag
  // 过滤图集关联且用户是白名单
  const isAtlas = product.atlasFlag && isAllCalUser.value
  // 过滤韩国仓非品牌商品
  const isKR = product.country === COUNTRY.KR && !product.productBrandId

  if (isNotChoice || isAtlas || isKR) {
    return false
  }
  return true
})
// 选择sku
const amount = ref<Record<string, any>>({})
const num = ref(0)

const calcObj = ref<{
  totalAmt?: number | string,
  totalAmtCn?: number | string,
  singleAmt?: number | string,
  singleAmtCn?: number | string,
  calcResult?: CalcResultVO
}>({
  totalAmt: 0,
  totalAmtCn: 0,
  singleAmt: 0,
  singleAmtCn: 0
})
const commonProductItemList: any = ref([])

// 发货附加项
let deliverAdditionList = reactive<CustomerAdditionRespDTO[]>([])
const showCalcModal = async () => {
  const realNewParams = JSON.parse(localStorage.getItem(calculatorStorageParam.value) ?? '{}')
  const { productParam } =
    realNewParams ?? {}
  commonProductItemList.value = productParam
  costVisible.value = true
  isOpenCalculator.value = true
}
const listenerFn = (data: any) => {
  const { type, data: list } = data.data
  if (type === 'updateGoods') {
    // 修改数量,体积，关税，商品附加项
    list.forEach((item: any) => {
      amount.value[item.productProperties].num = item.num
    })
    num.value = Object.values(amount.value).reduce((acc, v: any) => v.num + acc, 0)
  } else if (type === 'updateAddition') {
    deliverAdditionList = list ?? []
  }
}
microApp.addDataListener('my-app', listenerFn)
onUnmounted(() => {
  microApp.removeDataListener('my-app', listenerFn)
})
// 发货附加项变更
const updateAddition = (v: any) => {
  deliverAdditionList = v
}

const updateNum = (v: any) => {
  if (v.num > 0) {
    amount.value[v.productProperties] = v
  } else {
    delete amount.value[v.productProperties]
  }
  num.value = Object.values(amount.value).reduce((acc, v: any) => v.num + acc, 0)
}

const getShowProductProperties = (productProperties: string, productPropertiesName: string) => {
  const productProps = productProperties?.split(';')
  const productPropsNames = productPropertiesName?.split(';')
  const skuStrList: string[] = []
  productPropsNames?.forEach((name, index) => {
    skuStrList.push(name.replace(`${productProps?.[index]}:`, ''))
  })
  return skuStrList.join(';')
}

watch(num, (num) => {
  if (!props.isMultiGoods) {
    // 韩国商品不调用成本计算器计算价格接口
    computePrice()
  }
  // 一件代发不修改sku价格
  if (saleType.value === 2) {
    return
  }
  const priceName = data.value.switchAllIncludePriceJp === 1 && isJA() ? 'allIncludePriceJp' : 'price'
  // 计算阶梯价
  const ladder = data.value.ladder
  const isUnderLineGoods = data.value.channel === 5
  // 剔除直播商品区间价
  const number = data.value?.skuList?.reduce((acc: any, v: any) => acc + (v.isLive ? 0 : v.num ?? 0), 0)
  if (ladder?.length > 0) {
    let price = ladder[0]?.[priceName]
    // 是否命中区间
    let isHave = false
    ladder.forEach((v: any) => {
      if (number >= v.count) {
        price = v[priceName]
        isHave = true
      }
    })
    // 如果没有命中区间并且是线下商品不修改商品价格 处理异常数据区间价起始值不为1的情况
    if (!isHave && isUnderLineGoods) return
    data.value.skuList?.forEach((v: any) => {
      if (v.isLive) return
      v.productSellPrice = price
    })
  }
})

const [loading, api] = useRequest(addCartApi)
const addCart = () => {
  if (loading.value) return
  if (num.value === 0) {
    ElMessage.error(t('购买数量不可为空'))
    return
  }
  loading.value = true
  confirmLogin(async () => {
    if (visibleOnce.value === false) {
      const first = await isFirstAdd().then((res) => res.data ?? false)
      visibleOnce.value = first
      if (visibleOnce.value) {
        loading.value = false
        return
      }
    }
    const cartAdditionList: any = await setAdt(
      String(data.value.productCategoryFrontendNdId),
      'cartAdditionList',
      'noAdditionalFlag',
      [],
      undefined,
      props.isMultiGoods
    )
    const commonProductItemList = Object.values(amount.value).map((v: any) => {
      const additionList = calcParmas.value.productParam?.find(i => i.productSku === v.productSku)?.additionList

      const params = {
        season: v.season,
        productSku: v.productSku,
        orderQuantity: v.num,
        ...cartAdditionList,
        livePriceFlag: v.isLive ? 1 : 0,
        productSellPrice: v.productSellPrice
      }
      if (props.product.isAllCal) {
        params.cartAdditionList = additionList
      }
      return params
    })

    api({ addCartSource: 1, commonProductItemList, allIncludeFlag: props.product.isAllCal || (props.product?.switchAllIncludePriceJp === 1 && isJA()) ? 1 : 0 }).then(async (res) => {
      if (res?.success) {
        if (props.product.isAllCal && commonProductItemList.find(i => !i.season) && !props.product.switchAllIncludePriceJp) {
          ElMessage.error(t('加购成功。其中有商品没有计价规格，请联系业务补充。'))
        }
        await confirmFinishAdd({
          total: num.value,
          countryCode: data.value.country ?? '',
          isAll: props.product.isAllCal || ((!!props.product.switchAllIncludePriceJp) && isJA())
        })
        nextTick(() => {
          num.value = 0
          Object.keys(amount.value).forEach((key) => {
            amount.value[key].num = 0
            delete amount.value[key]
          })
        })
      }
    })
  }, () => {
    loading.value = false
  })
}

const download = async () => {
  // const hasMark = false
  // 日本站countryProductTag==1 其他productTag===1
  // const needMark = (props.product.productTag === 1 && !isJA()) || (isJA() && props.product.countryProductTag === 1)
  // if (needMark) {
  // }
  // await getLimitNum()
  // if (vipNum.value.Y === 0 && vipNum.value.X !== -1) {
  //   hasMark = true
  // }
  const data: any = [
    {
      fold: 'main',
      files: props.product.productItemImgs?.map((v: any) => v.url)
    }
  ]
  if (props.product.productDescImgs) {
    data.push({ fold: 'detail', files: props.product.productDescImgs })
  }
  // if (hasMark) {
  //   ElMessage.error(t('该商品无法下载商品图'))
  // } else {
  saveImgs(props.product.productTitle ?? '', data, false).then(() => {
    // if (needMark) {
    // }
    // postAddNum({ productCode: props.product.productCode ?? '' })
    // getLimitNum()
  })
  // }
}

const passData = async (data: any) => {
  const res = await getLimitNum()
  if (vipNum.value.Y === 0 && vipNum.value.X !== -1) {
    openUpVipVisible.value = true
    return
  }
  confirmLogin(() => {
    visible.value = true
  })
}
// 确定传输商品
const sureToShop = async () => {
  visible.value = false
  const customerShopId = store.getters.curShop
  const unbind = await confirmApiUnbind()
  if (unbind) return
  const shop = await getShopInfo({ customerShopId }).then((res) => res.data)
  if (shop.customerShopAuthStatus !== 1) {
    ElMessageBox.alert(
      t('仅支持已授权店铺上传商品，该店铺未授权'),
      t('传输商品信息到店铺'),
      {
        confirmButtonText: t('去授权'),
        type: 'warning',
        closeOnClickModal: true
      }
    )
      .then(() => {
        router.push(useRtfix('AuthorizedStore'))
      })
      .catch(() => { })
  } else {
    if (store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK) {
      // 是否设置 tiktok仓库信息
      const res = await ttsCreatProductCheck({ productCode: data.value.productCode })
      if (res.data) {
        tiktokUpRef.value?.show({
          productCode: data.value.productCode,
          languageCode: languageCode.value,
          purchaseChannel: String(data.value?.channel)
        })
      } else {
        ElMessage.error(t('请先在tiktok设置仓库信息'))
      }
    } else {
      ElMessageBox.alert(t('上传中...'), t('传输商品信息到店铺'), {
        showConfirmButton: false,
        customClass: 'stupid-el',
        type: 'success'
      }).catch(() => { })
      await publishProduct({ productCode: data.value.productCode!, languageCode: languageCode.value, purchaseChannel: String(data.value?.channel) }).then(
        (res) => {
          const a: any = document.querySelector('.stupid-el')
          if (a) {
            const m = a.parentNode.parentNode
            m.parentNode.removeChild(m)
          }
          if (res.success) {
            getLimitNum()
            ElMessageBox.alert(
              t('创建成功，并已为您自动创建关联'),
              t('传输商品信息到店铺'),
              {
                confirmButtonText: t('查看关联商品库'),
                type: 'success',
                closeOnClickModal: true
              }
            )
              .then(() => {
                router.push(useRtfix('AssociatedProductlib'))
              })
              .catch(() => { })
          }
        }
      )
    }
  }
}

const getRangePriceByStation = (productSellPriceRange = '') => {
  if (!String(productSellPriceRange).includes('-')) return calcCeil(productSellPriceRange, props.product?.currency)
  const [start, end] = productSellPriceRange.split('-').map((v) => calcCeil(v, props.product?.currency))

  return [start, end].join('-')
}
const checkBlack = (e: any) => {
  if (props?.product?.shopIsBlack === 1) {
    ElMessage.warning(t('该供应商因次品过多，无法购买其产品'))
    e.preventDefault()
  }
}
// 售卖模式1批发2一件代发
const saleType = ref(Number(route.query.tab ?? 1))
// 是否一件代发
const isOneSend = computed(() => {
  return props.product.isOnePsale && !props.isLive
})

const customerShopId = computed(() => store.getters.curShop)
const changeTab = (number: number) => {
  saleType.value = number
  router.replace({ query: { tab: number.toString() } })
  // 切换sku时把数量清空
  amount.value = {}
  num.value = 0
  const ladder = data.value.ladder
  const price = ladder[0]?.price
  // const ld = data?.productPriceLadderList || []
  data.value.skuList?.forEach((i: any) => {
    i.num = 0
    i.productSellPrice = number === 1 ? (price || i.originSkuPrice) : i.consignPrice
  })
}
// 是否打开过成本计算器，未打开计算成本按照附加项+商品 打开过从localstorage取goods_Calculator
const isOpenCalculator = ref(false)

const shipParam = ref<ShipParamVO | undefined>()
const showSkuTour = () => {
  tourOpen.value = true
  document.getElementsByClassName('goods-sku-stepper')[0]?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  })
}
const closeSkuTour = () => {
  tourOpen.value = false
}
/** 物流 */
const shopConfigExpress = ref<CustomerShopShipRespDTO>()
/** 发货附加项 */
const cartAdditionList = ref<any>([])
watch(() => isLogin.value, async (val) => {
  // 关闭状态
  const { data: additionData } = await getAdtList({ productType: 1, source: 1 })
  deliverAdditionList = additionData?.deliveryAdditionList?.filter((v: any) => v.additionCode === (isD2C() ? 42 : 23)) ?? []
  if (isD2C()) {
    // 店铺发货附加险 2c取店铺附加险 2b默认为空
    const { data: shopData }: any = await getShopLogistics()
    if (shopData?.additionItemList?.length > 0) {
      const newAdditionList: any[] = []
      shopData?.additionItemList.forEach((shopAddition: any) => {
        const currentAddition = additionData.deliveryAdditionList.find((item: any) => item.additionCode === shopAddition.additionCode)
        if (currentAddition) {
          newAdditionList.push(currentAddition)
        }
      })
      deliverAdditionList = newAdditionList
    }
  }
  if (val) {
    cartAdditionList.value = await setAdt(
      String(data.value.productCategoryFrontendNdId), 'cartAdditionList', 'noAdditionalFlag', [], undefined,
      props.isMultiGoods
    )

    if (customerShopId.value) {
      // 获取店铺物流
      const { data } = await request.customer.shop.shipGet({ customerShopId: customerShopId.value })
      const configItem = data?.find((v) => v.countryCode === getCustomerNationCode2())
      shopConfigExpress.value = configItem
    }
  }
}, { immediate: true })

/** 成本计算器计算价格 */
const computePrice = debounce(async () => {
  if (num.value === 0) {
    calcObj.value = {
      totalAmt: 0,
      totalAmtCn: 0,
      singleAmt: 0,
      singleAmtCn: 0
    }
    localStorage.removeItem(calculatorStorageParam.value)
    return
  }

  const realNewParams = JSON.parse(localStorage.getItem(calculatorStorageParam.value) ?? '{}') as extCalcParamVO
  const { deliverAdditionParam, inventoryParam, membershipTemplateId, productParam, taxParam, transportType, additionList } = realNewParams
  const nproductParam = Object.values(amount.value).map((v: any) => {
    const realItem: any = productParam?.find((i) => i.productSku === v.productSku)
    return {
      adaptTypeModifyFlag: v?.adaptTypeModifyFlag ?? !v.season,
      additionIdList: realItem?.additionIdList ?? v?.additionIdList ?? cartAdditionList.value?.cartAdditionList?.map((v) => v.additionId) ?? [],
      additionList: realItem?.additionList ?? v.additionList ?? cartAdditionList.value?.cartAdditionList,
      productPropertiesName: getShowProductProperties(v.productProperties, v.productPropertiesName),
      productProperties: v.productProperties,
      productTitle: props.product.productTitle,
      num: v.num,
      productSku: v.productSku,
      productSkuImg: v.productSkuImg ?? props.product.productSkuImg,
      fixedPriceFlag: props.product.fixedPriceFlag,
      productType: 1,
      productSellPrice: v.productSellPrice,
      productCode: props.product.productCode,
      taxInfo: realItem?.taxInfo ?? v.taxInfo,
      categoryCode: realItem?.categoryCode || v?.categoryCode,
      adaptType: realItem?.adaptType ?? v.adaptType,
      productAttribute: realItem?.productAttribute ?? {
        width: v.width,
        height: v.height,
        length: v.length,
        weight: Number(v.weight)
      }
    }
  })
  const params: extCalcParamVO = {
    additionList: additionList ?? deliverAdditionList,
    calcType: props.product.isAllCal ? 2 : 1,
    deliverAdditionParam: {
      additionIdList: additionList?.map((v) => v.additionId!) ?? deliverAdditionList?.map((v) => v.additionId!)
    },
    feeList: props.product.isAllCal ? [0, 1, 2, 7, 8, 9, 10] : [0, 1, 2, 3, 4, 5, 6, 7],
    inventoryParam: {
      days: inventoryParam?.days ?? 0
    },
    taxParam: {
      taxType: taxParam?.taxType ?? 2
    },
    membershipTemplateId: membershipTemplateId ?? showMembershipTemplateId.value,
    transportType: transportType ?? 1,
    productParam: nproductParam,
    shipParam: {
      ...shopConfigExpress.value,
      countryCode: useSite2Code(),
      intShipConfigId: undefined,
      packageAttribute: {
        height: undefined,
        length: undefined,
        weight: 0,
        width: undefined
      },
      wareCode: '1513770467071086592'
    },
    stationCode: useSite2Station(),
    systemSource: isD2C() ? 1 : 2
  }

  const [weight, volume] = calculateTotalWeightAndVolume(params.productParam)
  params.shipParam!.packageAttribute = {
    weight,
    volume,
    height: undefined,
    length: undefined,
    width: undefined
  }
  shipParam.value = params.shipParam
  if (params.productParam?.length === 0) return
  if (props.product.isAllCal) {
    params.productParam = params.productParam?.filter(i => i.adaptType)
    if (!params.productParam?.length) return
  }
  const { data: priceData } = await request.settlement.calc.execute(params)
  const realNum = priceData?.productResult?.productPriceResult?.reduce((pre, cur) => {
    return pre + Number(cur.num)
  }, 0) ?? 0
  calcParmas.value = params
  calcObj.value = {
    totalAmt: priceData?.totalAmt ?? '-',
    totalAmtCn: priceData?.totalAmtCn ?? '-',
    singleAmt: priceData?.totalAmt ? (isEN() ? ((priceData.totalAmt / realNum).toFixed(2)) : (Math.ceil(priceData.totalAmt / realNum).toFixed(0))) : '-',
    singleAmtCn: priceData?.totalAmtCn ? (priceData.totalAmtCn / realNum).toFixed(2) : '-',
    calcResult: priceData
  }
}, 200)
// 关闭窗口后重新计算价格
const close = () => {
  computePrice()
}
const calculateTotalWeightAndVolume = (
  productParam?: any[]
) => {
  if (!productParam || productParam.length === 0) return [0, 0]
  const list: any[] = []
  productParam.forEach((item) => {
    const { height, length, weight, width } = item?.productAttribute ?? {}
    if (height && length && weight && width && item.num) {
      list.push({
        attribute: {
          height,
          length,
          weight,
          width,
          volume: height * length * width
        },
        num: item.num
      })
    }
    item.combinationProductItemList?.forEach((temp: any) => {
      const { height, length, weight, width } =
        temp?.productAttribute ?? {}
      if (height && length && weight && width && item.num) {
        list.push({
          attribute: {
            height,
            length,
            weight,
            width,
            volume: height * length * width
          },
          num: temp.unitNums * item.num
        })
      }
    })
  })
  if (list?.length > 0) {
    const weight = list.reduce((pre, cur) => {
      return pre + (cur?.attribute?.weight ?? 0) * (cur?.num ?? 0)
    }, 0)
    const volume = list.reduce((pre, cur) => {
      return pre + (cur?.attribute?.volume ?? 0) * (cur?.num ?? 0)
    }, 0)
    return [weight, volume]
  }
  return [0, 0]
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "column-sku",
    style: _normalizeStyle({ width: ['OL', 'YS', 'XZ'].includes(__props.product.platformType ?? '') ? '730px' : '570px' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(isJA)() ? (_unref(data).productTitleJp || _unref(data).productTitle) : _unref(data).productTitle) + " ", 1),
      (!_unref(data).adaptTypeModifyFlag && _unref(data).seasonTag && _unref(data).categoryCode === '0001')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(data).seasonTag), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.product.supplierSpu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('商品番号')) + ":", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.product.supplierSpu), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(data).shopName && _unref(data).platformType !== 'YS' && _unref(data).channel !== 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(LogoIcon, {
            class: "mr_5",
            type: __props.product.platformType,
            url: __props.product.productDetailUrl,
            underline: __props.product.channel === 5,
            country: __props.product.country
          }, null, 8, ["type", "url", "underline", "country"]),
          (_unref(data).channel === 1 || (_unref(data).country === _unref(COUNTRY).KR && _unref(data).productBrandId))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: _unref(data).country === _unref(COUNTRY).KR ? _unref(useRtfix)('BrandDetail', { params: { brand: _unref(data).productBrandId ?? '' } }) : _unref(useRtfix)('list', { query: { shopCode: _unref(data).shopCode } }),
                onClickCapture: checkBlack
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(data).country === _unref(COUNTRY).KR ? _unref(data).productBrandName : _unref(data).shopName), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_unref(data).channel === 5)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClickCapture: checkBlack
                }, _toDisplayString(_unref(data).country === _unref(COUNTRY).KR ?
        _unref(data).productBrandName ?? '-' : _unref(data).shopName), 33))
              : (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _unref(data).shopUrl,
                  target: "_blank",
                  onClickCapture: checkBlack
                }, _toDisplayString(_unref(data).shopName), 41, _hoisted_7))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8)),
    (_unref(isJA)() && !__props.product.isAllCal && __props.product.switchAllIncludePriceJp !== 1 && _unref(isLogin))
      ? (_openBlock(), _createBlock(FreeShipping, {
          key: 3,
          scene: 1
        }))
      : _createCommentVNode("", true),
    (__props.product.productTag === 1 && !_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bus).emit('goCarefully'))),
          class: _normalizeClass(`selected-tag selected-tag-${_unref(useSite)()} flex-ter flex-bwn`)
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('·良品率高·价格竞争力高于其他店·1688畅销商品')), 1),
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('详情')), 1),
            _hoisted_11
          ])
        ], 2))
      : _createCommentVNode("", true),
    (__props.product.countryProductTag === 1 && _unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(bus).emit('goCarefully'))),
          class: "countryProductTag flex-ter flex-bwn"
        }, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('详情')), 1),
            _hoisted_14
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(isOneSend))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", {
            class: _normalizeClass(["fee-tab-item", { 'active': saleType.value === 1 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(1)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('批发')), 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('有最小起订量限制，价格更优惠')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                    [_vShow, saleType.value === 1]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
                    [_vShow, saleType.value === 2]
                  ])
                ])
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["fee-tab-item", { 'active': saleType.value === 2 }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(2)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('一件购买')), 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('无最小起订量限制，可一件购买')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                    [_vShow, saleType.value === 2]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                    [_vShow, saleType.value === 1]
                  ])
                ])
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (!_unref(isOneSend) || saleType.value === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.isLive || __props.product.platformType !== 'PD')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (__props.product.switchAllIncludePriceJp !== 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(__props.isLive ? _unref(t)('直播价') : _unref(t)('价格1')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)('一口价')), 1)),
                    (_unref(isJA)() && __props.product?.switchAllIncludePriceJp === 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "fee-range",
                          style: _normalizeStyle(`color: var(--rpcolor)`)
                        }, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(formatMoneyRange)(_unref(data).finalProductSellPrice)) + "円", 1),
                          _createElementVNode("div", _hoisted_26, " (" + _toDisplayString(_unref(calcJpyToRmb)(_unref(data).finalProductSellPrice)) + "元 ) ", 1)
                        ], 4))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "fee-range",
                          style: _normalizeStyle(`color: ${_unref(stationCode) === _unref(Site).KO ? '#333333' : 'var(--rpcolor)'}`)
                        }, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data).finalProductSellPrice) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1),
                          _createElementVNode("div", _hoisted_28, " (" + _toDisplayString(_unref(formatMoneyDirection)(getRangePriceByStation(_unref(data).finalProductSellPrice))) + ") ", 1)
                        ], 4)),
                    ((!__props.isLive) && __props.product.productSellPriceType === 1 && __props.product.isCkbDiscount === 1 && !!_unref(memberRate))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 4,
                          class: "fee-tag",
                          src: `https://static-s.theckb.com/BusinessMarket/icon/1688selected/good-selected-price-${_unref(useSite)()}.png`,
                          alt: ""
                        }, null, 8, _hoisted_29))
                      : _createCommentVNode("", true),
                    ((!__props.isLive) && __props.product.productSellPriceType === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(t)('专属折扣价')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  ((!__props.isLive) && (__props.product.productSellPriceType === 1 || __props.product.productSellPriceType === 2) && _unref(data).productOriginPriceRangeJpy && _unref(data).productOriginPriceRangeJpy !== _unref(data).productSellPriceRangeJpy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('1688原价')), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(data).productOriginPriceRange) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)) + " (" + _toDisplayString(_unref(formatMoneyDirection)(
                  getRangePriceByStation(_unref(data).productOriginPriceRange))) + ") ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('起订量1')), 1),
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(data).productBuyMininum) + _toDisplayString(_unref(t)('件')), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)('价格1')), 1),
                    _createElementVNode("div", {
                      class: "fee-range",
                      style: _normalizeStyle(`color: ${_unref(stationCode) === _unref(Site).KO ? '#333333' : 'var(--rpcolor)'}`)
                    }, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(data).productOriginPriceRange) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1),
                      _createElementVNode("div", _hoisted_41, " (" + _toDisplayString(_unref(formatMoneyDirection)(
                    getRangePriceByStation(_unref(data).productOriginPriceRange))) + ") ", 1)
                    ], 4)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('拼团价')), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(data).finalProductSellPrice) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1),
                      _createElementVNode("span", _hoisted_46, " (" + _toDisplayString(_unref(formatMoneyDirection)(
                    getRangePriceByStation(_unref(data).finalProductSellPrice))) + ") ", 1),
                      _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)(
                    '我们会尽可能按拼团价为您购买，如无法按照拼团价购买，将会按照原价进行购买'
                  )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(t)('起订量1')), 1),
                    _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(data).productBuyMininum) + _toDisplayString(_unref(t)('件')), 1)
                  ])
                ])),
            (_unref(data).showLladder && !__props.isLive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(t)('价格1')), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('购买数量')), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).ladder, (v) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: v.buyamount,
                      class: "fx-1 flex-col-ard"
                    }, [
                      (_unref(data).switchAllIncludePriceJp === 1 && _unref(isJA)())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "stair-price",
                            style: _normalizeStyle(`color: var(--rpcolor)`)
                          }, [
                            _createElementVNode("div", null, _toDisplayString(_unref(formatMoneyRange)(v.allIncludePriceJp)) + "円", 1),
                            _createElementVNode("div", null, " (" + _toDisplayString(_unref(calcJpyToRmb)(v.allIncludePriceJp)) + "元) ", 1)
                          ], 4))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "stair-price",
                            style: _normalizeStyle(`color: ${_unref(stationCode) === _unref(Site).KO ? '#333333' : 'var(--rpcolor)'}`)
                          }, [
                            _createElementVNode("div", null, _toDisplayString(v.price) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1),
                            _createElementVNode("div", null, " (" + _toDisplayString(_unref(formatMoneyDirection)(_unref(calcCeil)(v.price, __props.product.currency))) + ") ", 1)
                          ], 4)),
                      _createElementVNode("div", _hoisted_54, _toDisplayString(v.text), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_unref(isOneSend) && saleType.value === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(t)('价格1')), 1),
                _createElementVNode("div", {
                  class: "fee-range",
                  style: _normalizeStyle(`color: ${_unref(stationCode) === _unref(Site).KO ? '#333333' : 'var(--rpcolor)'}`)
                }, [
                  _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(data).consignRangePrice) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1),
                  _createElementVNode("div", _hoisted_59, " (" + _toDisplayString(_unref(formatMoneyDirection)(getRangePriceByStation(_unref(data).consignRangePrice))) + ") ", 1)
                ], 4)
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    (!_unref(store).getters.token)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_unref(t)('该价格仅供参考，请登录后获取实际价格信息')), 1))
      : _createCommentVNode("", true),
    (!__props.isMultiGoods && !__props.product.switchAllIncludePriceJp && __props.product.purchaseCountry !== 'JP')
      ? (_openBlock(), _createElementBlock("div", {
          key: 8,
          class: _normalizeClass(["base-price", { 'all-price-active': __props.product.isAllCal, 'd2c': _unref(isD2C)() }])
        }, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              (_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_63))
                : (_openBlock(), _createElementBlock("img", _hoisted_64)),
              _createTextVNode(" " + _toDisplayString(__props.product.isAllCal ? _unref(t)('全包价成本计算器') : _unref(t)('成本计算器')), 1)
            ]),
            (num.value === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(t)('请先在下方选择SKU')), 1),
                  _createElementVNode("div", {
                    class: "edit",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showSkuTour()))
                  }, _toDisplayString(_unref(t)('去选择')) + ">", 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["price-estimate", __props.product.isAllCal ? 'allCal' : ''])
                }, [
                  (!__props.product.isAllCal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(t)('总预估成本价')) + "：", 1),
                            (calcObj.value.totalAmtCn)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(calcObj.value.totalAmtCn) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)) + " (" + _toDisplayString(_unref(formatMoneyDirection)(calcObj.value.totalAmt)) + " )", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_71, "-"))
                          ]),
                          _hoisted_72,
                          _createElementVNode("span", _hoisted_73, _toDisplayString(num.value) + _toDisplayString(_unref(t)('件')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(t)('单品预估成本价')) + "： " + _toDisplayString(calcObj.value.singleAmtCn) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)) + "（" + _toDisplayString(_unref(formatMoneyDirection)(calcObj.value.singleAmt)) + "）", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(t)('单品预估成本价')) + "：", 1),
                            _createElementVNode("span", _hoisted_78, [
                              _createElementVNode("span", _hoisted_79, _toDisplayString(_unref(formatMoneyDirection)(calcObj.value.singleAmt, true)), 1),
                              _createTextVNode(" (" + _toDisplayString(calcObj.value.singleAmtCn) + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)) + ")", 1)
                            ])
                          ])
                        ])
                      ])),
                  _createElementVNode("div", {
                    class: "edit",
                    onClick: showCalcModal
                  }, _toDisplayString(_unref(t)('修改')) + "> ", 1)
                ], 2))
          ]),
          (__props.product.isAllCal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_unref(t)('该商品可计算全包价，价格仅供参考，实际价格以下单为准')), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_81, [
      (_unref(data).productPropGroupList)
        ? (_openBlock(), _createBlock(SkuMap, {
            key: 0,
            calcResult: calcObj.value.calcResult,
            skuProps: _unref(data).productPropGroupList,
            skuList: _unref(data).skuList,
            amount: amount.value,
            onUpdateNum: updateNum,
            product: _unref(data),
            num: num.value,
            saleType: saleType.value,
            tourOpen: tourOpen.value,
            closeSkuTour: closeSkuTour,
            isMultiGoods: __props.isMultiGoods
          }, null, 8, ["calcResult", "skuProps", "skuList", "amount", "product", "num", "saleType", "tourOpen", "isMultiGoods"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_loading, __props.skuLoading]
    ]),
    _createVNode(AbnormalGoodsTip, {
      style: {"margin-bottom":"22px"},
      productCode: _unref(data).productCode,
      product: _unref(data)
    }, null, 8, ["productCode", "product"]),
    _createVNode(BlackWarningTip, { item: _unref(data) }, null, 8, ["item"]),
    (!_unref(needAuth))
      ? (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["action", _unref(useSite)()]),
          key: _unref(data).productCode
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              onClick: addCart,
              loading: _unref(loading),
              class: "btn-width",
              disabled: _unref(isBlackGood) || (!_unref(isMultiStore)() && _unref(data).country === _unref(COUNTRY).KR) || (_unref(data).country === _unref(COUNTRY).KR && !_unref(data).productBrandId)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('加入购物车')), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            (_unref(isD2C)() && !_unref(underlineGood) && _unref(data).switchAllIncludePriceJp !== 1 && __props.product.purchaseCountry !== 'JP')
              ? (_openBlock(), _createBlock(memberEventBox, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (passData(_unref(data)))),
                      class: "btn-width",
                      disabled: _unref(isBlackGood) || _unref(curshop).customerShopPlatform === 7
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            style: _normalizeStyle(_unref(isEN)() ? 'white-space: break-spaces;' : '')
                          }, _toDisplayString(_unref(t)('传输到我的店铺')), 5),
                          (_unref(isMark) && _unref(membership)?.templateLevel > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, " (" + _toDisplayString(vipNum.value.X === -1 || vipNum.value.Y > 0 ? _unref(t)('无水印') : _unref(t)('有水印')) + ") ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (!_unref(underlineGood))
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createVNode(_component_el_button, {
                  plain: "",
                  type: "primary",
                  onClick: download,
                  class: "btn-width",
                  disabled: _unref(isBlackGood)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        style: _normalizeStyle(_unref(isEN)() ? 'white-space: break-spaces;' : '')
                      }, _toDisplayString(_unref(t)('下载商品图')), 5)
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                (_unref(isD2C)() && _unref(data).switchAllIncludePriceJp !== 1)
                  ? (_openBlock(), _createBlock(memberEventBox, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "btn-width",
                          disabled: _unref(isBlackGood)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: _unref(useRtfix)('CreateAssociated', {
              query: { productCode: _unref(data).productCode, productType: 1 },
            })
              ,
                              custom: ""
                            }, {
                              default: _withCtx(({ href }) => [
                                _createElementVNode("a", {
                                  href: _unref(isBlackGood) ? 'javascript:;' : href,
                                  class: _normalizeClass(["el-button el-button--primary", { 'is-disabled': _unref(isBlackGood) }])
                                }, _toDisplayString(_unref(t)('关联到我的店铺商品')), 11, _hoisted_84)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_85, [
          (_unref(needAuth) === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["auth-btn flex-center", (_unref(membership)?.templateLevel === 0 ? 'member_long' : '') + ' ' + _unref(useSite)()]),
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(toAuth) && _unref(toAuth)(...args)))
                }, _toDisplayString(_unref(t)('授权申请')), 3),
                _createElementVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _createElementVNode("div", _hoisted_88, _toDisplayString(_unref(t)('请前往进行品牌授权后，方可购买')), 1)
                ])
              ], 64))
            : (_unref(needAuth) === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_unref(t)('申请中')), 1))
              : (_unref(needAuth) === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_unref(t)('已下架')), 1))
                : _createCommentVNode("", true)
        ])),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((visible).value = $event)),
      "append-to-body": true,
      top: "42vh",
      width: "300px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, _toDisplayString(_unref(t)('请选择要翻译的语种')), 1),
          _createElementVNode("div", _hoisted_93, [
            (_unref(isJA)())
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  size: "small",
                  modelValue: languageCode.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((languageCode).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "日本語(Japanese)",
                      value: "ja"
                    }),
                    _createVNode(_component_el_option, {
                      label: "英語(English)",
                      value: "en"
                    }),
                    _createVNode(_component_el_option, {
                      label: "韓国語(Korean)",
                      value: "ko"
                    }),
                    _createVNode(_component_el_option, {
                      label: "マレー語(Malay)",
                      value: "ms"
                    }),
                    _createVNode(_component_el_option, {
                      label: "タイ語(Thai)",
                      value: "th"
                    }),
                    _createVNode(_component_el_option, {
                      label: "中国語(Chinese)",
                      value: "zh"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_unref(isKO)())
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  size: "small",
                  modelValue: languageCode.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((languageCode).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "일본어(Japanese)",
                      value: "ja"
                    }),
                    _createVNode(_component_el_option, {
                      label: "영어(English)",
                      value: "en"
                    }),
                    _createVNode(_component_el_option, {
                      label: "한국어(Korean)",
                      value: "ko"
                    }),
                    _createVNode(_component_el_option, {
                      label: "말레이어(Malay)",
                      value: "ms"
                    }),
                    _createVNode(_component_el_option, {
                      label: "태국어(Thai)",
                      value: "th"
                    }),
                    _createVNode(_component_el_option, {
                      label: "중국어(Chinese)",
                      value: "zh"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_unref(isEN)())
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 2,
                  size: "small",
                  modelValue: languageCode.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((languageCode).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Japanese",
                      value: "ja"
                    }),
                    _createVNode(_component_el_option, {
                      label: "English",
                      value: "en"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Korean",
                      value: "ko"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Malay",
                      value: "ms"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Thai",
                      value: "th"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Chinese",
                      value: "zh"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              class: "ml_20",
              size: "small",
              type: "primary",
              onClick: sureToShop
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ColumnModal, {
      modelValue: visibleOnce.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((visibleOnce).value = $event)),
      onOk: addCart
    }, null, 8, ["modelValue"]),
    _createVNode(PreviewSku, {
      product: _unref(data),
      sku: amount.value
    }, null, 8, ["product", "sku"]),
    _createVNode(CommonDialog, {
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (openUpVipVisible.value = false)),
      className: "waring_dialog",
      visible: openUpVipVisible.value,
      width: 480,
      "append-to-body": ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_94, [
          _hoisted_95,
          _createTextVNode(" " + _toDisplayString(_unref(t)('提醒')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_96, _toDisplayString(_unref(t)('抱歉，您的无水印次数已达上限，升级会员享受无限次。')), 1),
        _createElementVNode("div", _hoisted_97, [
          _createVNode(_component_el_button, {
            type: "default",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (openUpVipVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            color: "#008060",
            onClick: upVipClick,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('升级会员')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(TiktokUp, {
      product: __props.product,
      ref: (_value, _refs) => {
        _refs['tiktokUpRef'] = _value
        tiktokUpRef.value = _value
      },
      onSuccess: getLimitNum
    }, null, 8, ["product"]),
    (costVisible.value)
      ? (_openBlock(), _createBlock(CostCalc, {
          key: 11,
          visible: costVisible.value,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((costVisible).value = $event)),
          from: "goods",
          product: _unref(data),
          onUpdateAddition: updateAddition,
          onUpdateNum: updateNum,
          data: commonProductItemList.value,
          onClose: close,
          shipParam: shipParam.value
        }, null, 8, ["visible", "product", "data", "shipParam"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})